import React, { useState, useCallback } from 'react'
import { Box, Button, Flex, InjectedModalProps, LinkExternal, useTooltip, HelpIcon, Message, Text, Skeleton, AutoRenewIcon, Spinner } from '@pancakeswap/uikit'
import { useWeb3React } from '@web3-react/core/core/core'
import { getaceAddress, getataliraAddress, getbabyvizslaAddress, getbtntyAddress, getbuildAddress,getFarm2Address, getBusdAddress, getbvcAddress, getCakeAddress, getetcAddress, getethAddress, getexzoAddress, getfpsAddress, getHVIAddress, getLAMEAAddress, getlgcAddress, getliraAddress, getltcAddress, gettripAddress, getWbnbAddress, getbabyAddress, getVNAddress, getbtcAddress, getcubyAddress, getFRTCAddress } from 'utils/addressHelpers'
import useTokenBalance, { useTotalSupply, useVizslaLPBalance, useGetBnbBalance, useHVILPBalance ,useTotalSupplyVIZSLAHVI, useFarm1,useFarm23, useFarm24, useTotalSupplyFarm24, useFarm22,useTotalSupplyFarm1 ,useTotalSupplyFarm23,useTotalSupplyFarm22, useMaster1 , useFarm2 ,useFarm3,useFarm4, useTotalSupplyFarm2, useTotalSupplyFarm3, useTotalSupplyFarm4, useFarm5, useTotalSupplyFarm5, useFarm6 , useTotalSupplyFarm6 , useFarm7 , useTotalSupplyFarm7 , useFarm8, useTotalSupplyFarm8, useFarm9, useTotalSupplyFarm9 , useFarm10, useTotalSupplyFarm10 , useFarm11, useTotalSupplyFarm11, useFarm12, useFarm13, useFarm14, useFarm15, useFarm16, useFarm17, useFarm18, useFarm19, useFarm20, useFarm21, useTotalSupplyFarm12, useTotalSupplyFarm13, useTotalSupplyFarm14,useTotalSupplyFarm15, useTotalSupplyFarm16, useTotalSupplyFarm17, useTotalSupplyFarm18, useTotalSupplyFarm19, useTotalSupplyFarm20,useTotalSupplyFarm21 } from 'hooks/useTokenBalance'
import useAuth from 'hooks/useAuth'
import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'
import { getBscScanLink } from 'utils'
import useToast from 'hooks/useToast'
import { updateUserStakedBalance } from 'state/pools'
import { getBalanceNumber, getFullDisplayBalance , getFullDisplayBalance2} from 'utils/formatBalance'
import { useMasterchef } from 'hooks/useContract'
import { harvestFarm } from 'utils/calls'
import Balance from 'components/Balance'
import BigNumber from 'bignumber.js/bignumber'
import useFarmsWithBalance from 'views/Home/hooks/useFarmsWithBalance'
import { usePriceAceBusd, usePriceATALIRABusd, useFarmUser, usePriceBABYVIZSLABusd, usePriceBnbBusd, usePriceBtntyBusd, usePricebuildBusd, usePriceBVCBusd, usePriceCakeBusd, usePriceETCBusd, usePriceETHBusd, usePriceEXZOBusd, usePriceFpsBusd, usePriceHVIBusd , usePriceLameaBusd, usePriceLGCBusd, usePriceliraBusd, usePriceLTCBusd, usePricetripBusd, usePricebabyBusd, usePriceBTCBusd, usePricecubyBusd, usePricefrtcBusd} from 'state/farms/hooks'
import CopyAddress from './CopyAddress'


interface WalletInfoProps {
  hasLowBnbBalance: boolean
  hasLowGodBalance: boolean
  hasLowGod2Balance: boolean
  hasLowGod3Balance: boolean
  hasLowGod4Balance: boolean
  hasLowGod5Balance: boolean
  hasLowGod6Balance: boolean
  hasLowGod7Balance: boolean
  hasLowGod8Balance: boolean
  hasLowGod9Balance: boolean
  hasLowGod10Balance: boolean
  hasLowGodBalance11: boolean
  hasLowGodBalance12: boolean
  hasLowGodBalance13: boolean
  hasLowGodBalance14: boolean
  hasLowGodBalance15: boolean
  hasLowGodBalance16: boolean
  hasLowGodBalance17: boolean
  hasLowGodBalance18: boolean
  hasLowGodBalance19: boolean
  hasLowGodBalance20: boolean
  hasLowGodBalance21: boolean
  hasLowGodBalance22: boolean
  hasLowGodBalance23: boolean
  hasLowGodBalance24: boolean
  hasLowGodBalanceN: boolean
  hasLowGodBalance1X: boolean
  onDismiss: InjectedModalProps['onDismiss']
}

const WalletInfo: React.FC<WalletInfoProps> = ({hasLowBnbBalance, hasLowGod2Balance, hasLowGodBalanceN, hasLowGodBalance23, hasLowGodBalance24,hasLowGodBalance21, hasLowGodBalance22, hasLowGodBalance, hasLowGod3Balance,hasLowGodBalance1X,hasLowGod4Balance, hasLowGod5Balance, hasLowGod6Balance, hasLowGod7Balance, hasLowGod8Balance, hasLowGod9Balance, hasLowGod10Balance, hasLowGodBalance11,hasLowGodBalance12, hasLowGodBalance13, hasLowGodBalance14, hasLowGodBalance15, hasLowGodBalance16, hasLowGodBalance17, hasLowGodBalance18, hasLowGodBalance19,hasLowGodBalance20, onDismiss }) => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const [pendingTx, setPendingTx] = useState(false)
  const { toastSuccess, toastError } = useToast()
  const { balance } = useGetBnbBalance()
  const { balance: cakeBalance } = useTokenBalance(getCakeAddress())
  const { balance: cakeBalance2 } = useTokenBalance(getHVIAddress()) 
  const { balance: cakeBalance3 } = useTokenBalance(getBusdAddress()) 
  const { balance: cakeBalance4 } = useTokenBalance(getLAMEAAddress()) 
  const { balance: cakeBalance5 } = useTokenBalance(getlgcAddress()) 
  const { balance: cakeBalance6 } = useTokenBalance(getbvcAddress()) 
  const { balance: cakeBalance7 } = useTokenBalance(getbabyvizslaAddress()) 
  const { balance: cakeBalance8 } = useTokenBalance(getWbnbAddress()) 
  const { balance: cakeBalance9 } = useTokenBalance(getfpsAddress()) 
  const { balance: cakeBalance10 } = useTokenBalance(getexzoAddress()) 
  const { balance: cakeBalance11 } = useTokenBalance(getataliraAddress()) 
  const { balance: cakeBalance12 } = useTokenBalance(gettripAddress()) 
  const { balance: cakeBalance13 } = useTokenBalance(getbuildAddress()) 
  const { balance: cakeBalance14 } = useTokenBalance(getliraAddress()) 
  const { balance: cakeBalance15 } = useTokenBalance(getaceAddress()) 
  const { balance: cakeBalance16 } = useTokenBalance(getbtntyAddress()) 
  const { balance: cakeBalance17 } = useTokenBalance(getltcAddress()) 
  const { balance: cakeBalance18 } = useTokenBalance(getethAddress()) 
  const { balance: cakeBalance19 } = useTokenBalance(getetcAddress()) 
  const { balance: cakeBalanceN } = useTokenBalance(getVNAddress())
  const { balance: cakeBalance20 } = useTokenBalance(getbabyAddress())
  const { balance: cakeBalance21 } = useTokenBalance(getbtcAddress())
  const { balance: cakeBalance22 } = useTokenBalance(getcubyAddress())
  const { balance: cakeBalance23 } = useTokenBalance(getFRTCAddress())

  
  const balanceNt = cakeBalanceN.toNumber()
  const price0 = usePriceCakeBusd()
  const price = price0.toNumber()
  const cakeBalancevizsla = cakeBalance.times(price)
  const { logout } = useAuth()
  const { farmsWithStakedBalance, earningsSum: farmEarningsSum } = useFarmsWithBalance()
  const lameaprice = usePriceLameaBusd()
  const lameaprice0 = lameaprice.toNumber()
  const lameafull = cakeBalance4.times(lameaprice0)
  const lgcprice0 = usePriceLGCBusd()
  const lgcprice = lgcprice0.toNumber()
  const lgcpricefull = cakeBalance5.times(lgcprice)
  const bvcprice0 = usePriceBVCBusd()
  const bvcprice = bvcprice0.toNumber()
  const bvcfull = cakeBalance6.times(bvcprice)
  const babyprice0 = usePriceBABYVIZSLABusd()
  const babyprice = babyprice0.toNumber()
  const babyfull = cakeBalance7.times(babyprice)
  const wbnbprice0 = usePriceBnbBusd()
  const wbnbprice = wbnbprice0.toNumber()
  const wbnbfull = cakeBalance8.times(wbnbprice)
  const fpsprice0 = usePriceFpsBusd()
  const fpsprice = fpsprice0.toNumber()
  const fpsfull = cakeBalance9.times(fpsprice)
  const exzoprice0 = usePriceEXZOBusd()
  const exzoprice = exzoprice0.toNumber()
  const exzofull = cakeBalance10.times(exzoprice)
  const ataliraprice = usePriceATALIRABusd()
  const ataliraprice1 = ataliraprice.toNumber()
  const atalirafull = cakeBalance11.times(ataliraprice1)
  const tripprice0 = usePricetripBusd()
  const tripprice = tripprice0.toNumber()
  const tripfull = cakeBalance12.times(tripprice)
  const buildprice0 = usePricebuildBusd()
  const buildprice = buildprice0.toNumber()
  const buildfull = cakeBalance13.times(buildprice)
  const liraprice0 = usePriceliraBusd()
  const liraprice = liraprice0.toNumber()
  const lirafull = cakeBalance14.times(liraprice)
  const aceprice0 = usePriceAceBusd()
  const aceprice = aceprice0.toNumber()
  const acefull = cakeBalance15.times(aceprice)
  const btntyprice = usePriceBtntyBusd()
  const btntyprice0 = btntyprice.toNumber()
  const btntyfull = cakeBalance16.times(btntyprice0)
  const ltcprice0 = usePriceLTCBusd()
  const ltcprice = ltcprice0.toNumber()
  const ltcfull = cakeBalance17.times(ltcprice)
  const ethprice0 = usePriceETHBusd()
  const ethprice = ethprice0.toNumber()
  const ethfull = cakeBalance18.times(ethprice)
  const etcprice0 = usePriceETCBusd()
  const etcprice = etcprice0.toNumber()
  const babyprice00 = usePricebabyBusd()
  const babypricee = babyprice00.toNumber()
  const babyfull0 = cakeBalance20.times(babypricee)
  const etcfull = cakeBalance19.times(etcprice)
  const masterChefContract = useMasterchef()
  const cakePriceBusd = usePriceCakeBusd()
  const earningsBusd = new BigNumber(farmEarningsSum).multipliedBy(cakePriceBusd)
  const numFarmsToCollect = farmsWithStakedBalance.length
  const bnbprice = usePriceBnbBusd()
  const bnbprice1 = bnbprice.toNumber()
  const cakebalance4 = balance.times(bnbprice1)
  const hviprice0 = usePriceHVIBusd()
  const hviprice = hviprice0.toNumber()
  const btcprice0 = usePriceBTCBusd()
  const btcfull = btcprice0.toNumber()
  const btcfull2 = cakeBalance21.times(btcfull)
  const cubyprice0 = usePricecubyBusd()
  const cubyfull = cubyprice0.toNumber()
  const cubyfull2 = cakeBalance22.times(cubyfull)
  const frtcprice0 = usePricefrtcBusd()
  const frtcpricefull = frtcprice0.toNumber()
  const frtcfull = cakeBalance23.times(frtcpricefull)
  const végre = cakeBalance2.times(hviprice)
  const { targetRef, tooltip, tooltipVisible } = useTooltip(t('You can view just Active VizslaSwap Tokens in your wallet.'), {
    placement: 'bottom',
  })
 
  const earningsText = t('%earningsBusd% Collect from %count% %farms%', {
    earningsBusd: earningsBusd.toString(),
    count: numFarmsToCollect > 0 ? numFarmsToCollect : '',
    farms: numFarmsToCollect === 0 || numFarmsToCollect > 1 ? 'farms' : 'farm',
  })
  const [preText, toCollectText] = earningsText.split(earningsBusd.toString())
  const earningsBusd2 = earningsBusd.div(cakePriceBusd)
  


  const handleLogout = () => {
    onDismiss()
    logout()
  }
  const harvestAllFarms = useCallback(async () => {
    setPendingTx(true)
    // eslint-disable-next-line no-restricted-syntax
    for (const farmWithBalance of farmsWithStakedBalance) {
      try {
        // eslint-disable-next-line no-await-in-loop
        await harvestFarm(masterChefContract, farmWithBalance.pid)
        toastSuccess(
          `${t('Harvested')}!`,
          t('Your %symbol% earnings have been sent to your wallet!', { symbol: 'VIZSLASWAP' }),
        )
      } catch (error) {
        toastError(t('Error'), t('Please try again. Confirm the transaction and make sure you are paying enough gas!'))
      }
    }
    setPendingTx(false)
  }, [farmsWithStakedBalance, masterChefContract, toastSuccess, toastError, t])

  return (
    <>
      <Text color="secondary" fontSize="12px" textTransform="uppercase" fontWeight="bold" mb="8px">
        {t('Your Address')}
      </Text>
      <CopyAddress account={account} mb="24px" />
      <Flex >
      <Text color="white" textAlign="left"  fontSize="15px" textTransform="uppercase" fontWeight="bold" mb="8px">
        {t('Token Balances')}
      </Text>  
      <Flex  ref={targetRef}>
                <HelpIcon color="textSubtle" ml="4px" mb="8px"  />
                </Flex>
              </Flex>
      {hasLowBnbBalance && (
           <Message variant="danger" mb="24px">
           <Box>
             <Text fontWeight="bold">{t('BNB Balance Low')}</Text>
             <Text as="p">{t('You need BNB for transaction fees.')}</Text>
           </Box>
         </Message>
      )}
      {hasLowGodBalance && !cakeBalance4.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/1.png" alt="router"  height="24px" width="24px" />
          <Text ml="7px" color="gold">{t('BNB')}</Text>
          </Flex>
          <Text>${getFullDisplayBalance(cakebalance4, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/1.png" alt="router"  height="0px" width="0px" />
          ) }

       {hasLowGod2Balance  && !cakeBalancevizsla.isNaN() ?   (
          <Flex alignItems="center"  mb="8px" justifyContent="space-between">
                        <Flex>

          <img src="/images/wallet/2.png"  alt="router"  height="24px" width="24px" />
          <Text ml="7px" color="primary">{t('VIZSLASWAP')}</Text>
          </Flex>
          <Text> ${getFullDisplayBalance(cakeBalancevizsla, 18, 2 )}</Text>
        </Flex>
 )  : (
  <img src="/images/wallet/1.png" alt="router"  height="0px" width="0px" />
  ) }
  
     {hasLowGod3Balance && !végre.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
              <Flex>
<img src="/images/wallet/3.png"  alt="router"  height="24px" width="24px" />
          <Text  ml="7px" color="primary">{t('HVI')}</Text>
          </Flex>
          <Text>${getFullDisplayBalance2(végre, 9, 2 )}</Text>
        </Flex>
    )  : (
      <img src="/images/wallet/1.png" alt="router"  height="0px" width="0px" />
      ) }
         {hasLowGod9Balance && !wbnbfull.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
           <img src="/images/wallet/9.png" alt="router"  height="24px" width="24px" />
          <Text ml="7px" color="textSubtle">{t('WBNB')}</Text>
          </Flex>
          <Text>${getFullDisplayBalance(wbnbfull, 18, 2)}</Text>
        </Flex>
          )  : (
            <img src="/images/wallet/1.png" alt="router"  height="0px" width="0px" />
            ) }
          {hasLowGod4Balance  && !cakeBalance3.isNaN() ?   (
          <Flex alignItems="center"  mb="8px" justifyContent="space-between">
                        <Flex>

          <img src="/images/wallet/4.png"  alt="router"  height="24px" width="24px" />
          <Text ml="7px" color="textSubtle">{t('BUSD')}</Text>
          </Flex>
          <Text> ${getFullDisplayBalance(cakeBalance3, 18, 2 )}</Text>
        </Flex>
 )  : (
  <img src="/images/wallet/1.png" alt="router"  height="0px" width="0px" />
  ) }
     {hasLowGod5Balance && !lameafull.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
              <Flex>
<img src="/images/wallet/5.png"  alt="router"  height="24px" width="24px" />
          <Text  ml="7px" color="textSubtle">{t('LAMEA')}</Text>
          </Flex>
          <Text>${getFullDisplayBalance(lameafull, 18, 2 )}</Text>
        </Flex>
 )  : (
  <img src="/images/wallet/1.png" alt="router"  height="0px" width="0px" />
  ) }
         {hasLowGod6Balance && !lgcpricefull.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
              <Flex>
<img src="/images/wallet/6.png"  alt="router"  height="24px" width="24px" />
          <Text  ml="7px" color="textSubtle">{t('LGC')}</Text>
          </Flex>
          <Text>${getFullDisplayBalance(lgcpricefull, 18, 2 )}</Text>
        </Flex>
 )  : (
  <img src="/images/wallet/1.png" alt="router"  height="0px" width="0px" />
  ) }
     {hasLowGod7Balance && !bvcfull.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
              <Flex>
<img src="/images/wallet/7.png"  alt="router"  height="24px" width="24px" />
          <Text  ml="7px" color="textSubtle">{t('BVC')}</Text>
          </Flex>
          <Text>${getFullDisplayBalance(bvcfull, 18, 2 )}</Text>
        </Flex>
 )  : (
  <img src="/images/wallet/1.png" alt="router"  height="0px" width="0px" />
  ) }
   {hasLowGod8Balance&& !babyfull.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
              <Flex>
<img src="/images/wallet/8.png"  alt="router"  height="24px" width="24px" />
          <Text  ml="7px" color="textSubtle">{t('BABYVIZSLA')}</Text>
          </Flex>
          <Text>${getFullDisplayBalance(babyfull, 18, 2 )}</Text>
        </Flex>
 )  : (
  <img src="/images/wallet/1.png" alt="router"  height="0px" width="0px" />
  ) }
         {hasLowGod10Balance && !fpsfull.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
              <Flex>
<img src="/images/wallet/10.png"  alt="router"  height="24px" width="24px" />
          <Text  ml="7px" color="textSubtle">{t('FPS')}</Text>
          </Flex>
          <Text>${getFullDisplayBalance(fpsfull, 18, 2 )}</Text>
        </Flex>
 )  : (
  <img src="/images/wallet/1.png" alt="router"  height="0px" width="0px" />
  ) }
       {hasLowGodBalance11 && !exzofull.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
              <Flex>
<img src="/images/wallet/11.png"  alt="router"  height="24px" width="24px" />
          <Text  ml="7px" color="textSubtle">{t('EXZO')}</Text>
          </Flex>
          <Text>${getFullDisplayBalance(exzofull, 9, 2 )}</Text>
        </Flex>
 )  : (
  <img src="/images/wallet/1.png" alt="router"  height="0px" width="0px" />
  ) }
              {hasLowGodBalance12 && !atalirafull.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
              <Flex>
<img src="/images/wallet/12.png"  alt="router"  height="24px" width="24px" />
          <Text  ml="7px" color="textSubtle">{t('ATALIRA')}</Text>
          </Flex>
          <Text>${getFullDisplayBalance(atalirafull, 9, 2 )}</Text>
        </Flex>
 )  : (
  <img src="/images/wallet/1.png" alt="router"  height="0px" width="0px" />
  ) }
             {hasLowGodBalance13 && !tripfull.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
              <Flex>
<img src="/images/wallet/13.png"  alt="router"  height="24px" width="24px" />
          <Text  ml="7px" color="textSubtle">{t('TRIP')}</Text>
          </Flex>
          <Text>${getFullDisplayBalance(tripfull, 18, 2 )}</Text>
        </Flex>
 )  : (
  <img src="/images/wallet/1.png" alt="router"  height="0px" width="0px" />
  ) }
                {hasLowGodBalance14 && !buildfull.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
              <Flex>
<img src="/images/wallet/14.png"  alt="router"  height="24px" width="24px" />
          <Text  ml="7px" color="textSubtle">{t('BUILD')}</Text>
          </Flex>
          <Text>${getFullDisplayBalance(buildfull, 18, 2 )}</Text>
        </Flex>
 )  : (
  <img src="/images/wallet/1.png" alt="router"  height="0px" width="0px" />
  ) }
           {hasLowGodBalance15 && !lirafull.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
              <Flex>
<img src="/images/wallet/15.png"  alt="router"  height="24px" width="24px" />
          <Text  ml="7px" color="textSubtle">{t('LIRA')}</Text>
          </Flex>
          <Text>${getFullDisplayBalance(lirafull, 18, 2 )}</Text>
        </Flex>
 )  : (
  <img src="/images/wallet/1.png" alt="router"  height="0px" width="0px" />
  ) }
          {hasLowGodBalance16 && !acefull.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
              <Flex>
<img src="/images/wallet/16.png"  alt="router"  height="24px" width="24px" />
          <Text  ml="7px" color="textSubtle">{t('ACE')}</Text>
          </Flex>
          <Text>${getFullDisplayBalance(acefull, 18, 2 )}</Text>
        </Flex>
 )  : (
  <img src="/images/wallet/1.png" alt="router"  height="0px" width="0px" />
  ) }
           {hasLowGodBalance17 && !btntyfull.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
              <Flex>
<img src="/images/wallet/17.png"  alt="router"  height="24px" width="24px" />
          <Text  ml="7px" color="textSubtle">{t('BTNTY')}</Text>
          </Flex>
          <Text>${getFullDisplayBalance(btntyfull, 18, 2 )}</Text>
        </Flex>
 )  : (
  <img src="/images/wallet/1.png" alt="router"  height="0px" width="0px" />
  ) }
         {hasLowGodBalance21 && !babyfull0.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
              <Flex>
<img src="/images/wallet/21.png"  alt="router"  height="24px" width="24px" />
          <Text  ml="7px" color="textSubtle">{t('BABY')}</Text>
          </Flex>
          <Text>${getFullDisplayBalance(babyfull0, 18, 2 )}</Text>
        </Flex>
 )  : (
  <img src="/images/wallet/1.png" alt="router"  height="0px" width="0px" />
  ) }
     {hasLowGodBalance18&& !ltcfull.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
              <Flex>
<img src="/images/wallet/18.png"  alt="router"  height="24px" width="24px" />
          <Text  ml="7px" color="textSubtle">{t('LTC')}</Text>
          </Flex>
          <Text>${getFullDisplayBalance(ltcfull, 18, 2 )}</Text>
        </Flex>
 )  : (
  <img src="/images/wallet/1.png" alt="router"  height="0px" width="0px" />
  ) }
    {hasLowGodBalance19 && !ethfull.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
              <Flex>
<img src="/images/wallet/19.png"  alt="router"  height="24px" width="24px" />
          <Text  ml="7px" color="textSubtle">{t('ETH')}</Text>
          </Flex>
          <Text>${getFullDisplayBalance(ethfull, 18, 2 )}</Text>
        </Flex>
 )  : (
  <img src="/images/wallet/1.png" alt="router"  height="0px" width="0px" />
  ) }

          {hasLowGodBalance20 && !etcfull.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
              <Flex>
<img src="/images/wallet/20.png"  alt="router"  height="24px" width="24px" />
          <Text  ml="7px" color="textSubtle">{t('ETC')}</Text>
          </Flex>
          <Text>${getFullDisplayBalance(etcfull, 18, 2 )}</Text>
        </Flex>
 )  : (
  <img src="/images/wallet/1.png" alt="router"  height="0px" width="0px" />
  ) }
           {hasLowGodBalance22 && !btcfull2.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
              <Flex>
<img src="/images/wallet/23.png"  alt="router"  height="24px" width="24px" />
          <Text  ml="7px" color="textSubtle">{t('BTCB')}</Text>
          </Flex>
          <Text>${getFullDisplayBalance(btcfull2, 18, 2 )}</Text>
        </Flex>
 )  : (
  <img src="/images/wallet/23.png" alt="router"  height="0px" width="0px" />
  ) }
   {hasLowGodBalance23 && !cubyfull2.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
              <Flex>
<img src="/images/wallet/24.png"  alt="router"  height="24px" width="24px" />
          <Text  ml="7px" color="textSubtle">{t('CUBY')}</Text>
          </Flex>
          <Text>${getFullDisplayBalance(cubyfull2, 18, 2 )}</Text>
        </Flex>
 )  : (
  <img src="/images/wallet/1.png" alt="router"  height="0px" width="0px" />
  ) }
     {hasLowGodBalance24 && !frtcfull.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
              <Flex>
<img src="/images/wallet/25.png"  alt="router"  height="24px" width="24px" />
          <Text  ml="7px" color="textSubtle">{t('FRTC')}</Text>
          </Flex>
          <Text>${getFullDisplayBalance(frtcfull, 18, 2 )}</Text>
        </Flex>
 )  : (
  <img src="/images/wallet/1.png" alt="router"  height="0px" width="0px" />
  ) }
      <Button variant="secondary" width="100%" onClick={handleLogout}>
        {t('Disconnect Wallet')}
      </Button>
      {tooltipVisible && tooltip}
    </>
  )
}

export default WalletInfo
